export default {
  interactiveComponent: 'Interactive Elements',
  endPane: {
    title: 'End Card',
    background: {
      label: 'Set Background',
      opaque: 'Opacity',
    },
  },
  jump: {
    title: 'Set Redirect',
    unit: 'Times',
    endToShop: 'Auto-redirect to app store after end',
    clickToShap: 'Auto-redirect to app store after specified number of clicks',
  },
  event: {
    label: 'Event',
    hot: 'Click Area',
    eventHand: 'Gesture',
    placeholder: 'Please Select',
    click: 'Click',
    swipe: 'Swipe',
    longPress: 'Long Press',
  },
  ivSetting: {
    interactive: 'Interaction',
    auto: 'Automatic',
    longPress: 'Long Press',
    method: 'Looping Mode',
    title: 'Interaction Settings',
    label: 'Interaction Type',
  },
  ivUnit: {
    freeze: 'Freeze',
    loop: 'Loop',
    longPress: 'Hold',
    play: 'Auto Redirection',
  },
  unitTip: {
    freeze: 'Freeze playable until user click',
    loop: 'Loop playable until user click',
    longPress: 'Resume playable when user tap',
  },
  loop: {
    single: 'One-way Cycle',
    both: 'Two-way Loop',
  },
  sync: {
    title: 'Edit Synchronization',
    content:
      'If other nodes contain the same video, do you want to synchronize the edits from other nodes to the current node? Once selected, it cannot be changed.',
    sync: 'Synchronize',
    noSync: 'Unsynchronize',
  },
  guideTip: {
    maskTip: 'Complete interactive video script editing by creating nodes.',
    knowMsg: 'Got it',
    firstStep:
      "Use 'Enter' to create a sibling node and 'Tab' to create a child node.",
    secondStep: 'Upload video to the project',
    thirdStep: 'Drag the video into the node',
    fourthStep:
      'Interactive elements can be added to the node to control video playback.',
    fifthStep:
      'The default interaction is auto redirection, and you can click to set the redirection method.',
  },
  validateTip: {
    banRemoveVideo: 'Cannot be deleted',
    banRemoveHotArea: 'Interactive settings between nodes cannot be deleted.',
  },
  segment: {
    hand: 'Interactive Area',
    videoNode: 'Video Node',
  },
  sceneErrorType: {
    noVideo: 'No video, cannot add resources.',
    noSpace: 'No position to place interactive elements',
    insertFail: 'Add Failed',
    segmentNotFound: 'Target Element Not Found',
    createNodeFail: 'Failed to create node for the corresponding element',
  },
  brain: {
    rule: {
      endding: 'End Card has been set',
    },
    node: {
      enddingname: 'End Card',
      videoname: 'Video Node',
      menu: {
        copy: 'Copy Node',
        paste: 'Paste Node',
        delete: 'Delete Node',
      },
      unitType: {
        rule: {
          tipsa:
            'Multiple click areas exist, unable to switch to automatic redirection',
          tipsb: 'Data not found, unable to switch',
        },
      },
      emptyNode: {
        title: 'No video information',
      },
      video: {
        rule: {
          tipsa: 'Video cannot be added to the End Card',
          tipsc: 'Nodes cannot be added with automatic redirection',
        },
      },
      editname: {
        title: 'Node Name',
      },
      sync: {
        tips: 'Synchronize with nodes containing the same video',
      },
    },
    board: {
      title: 'Storyboard',
      action: {
        upload: {
          title: 'Upload Video',
        },
        localUpload: {
          title: 'Upload',
        },
        lib: {
          title: 'Choose from Assets',
        },
      },
      exitFullScreen: 'Exit Fullscreen',
    },
    videoList: {
      title: 'Project Video',
      remove: {
        dialog: {
          title: 'Delete the added video',
          content:
            'Deleting the video added to the node will also delete all content within the node. Are you sure you to delete?',
        },
      },
    },
  },
  resource: {
    uploade: {
      rule: {
        video: {
          tips: 'Please upload video resources in the video panel',
        },
      },
    },
  },
}
